var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.47 6.47a.75.75 0 011.06 1.06L10.06 12l4.47 4.47a.75.75 0 01-1.06 1.06l-4.647-4.646a1.25 1.25 0 010-1.768L13.47 6.47z",
    fill: "currentColor"
  })));
}
SvgChevronLeft.displayName = 'ChevronLeft';
export default SvgChevronLeft;